import { eventChannel } from 'redux-saga';
import { fork, take, takeEvery, call, put, select, cancel } from 'redux-saga/effects';

//Translations
//import utilTranslations from '../../helpers/utilTranslations';

//Service
import WsService from 'plugins/TS-lib-utils-public/services/WsService';

//Selectors
import CONSTANTS from '../CONSTANTS';
import { getUser, getWebsocketLastAction, getKitList } from 'store/selectors/selectors';
import { actionSetLastData } from 'store/actions/websocketActions';
import { actionWsStatus } from 'store/actions/commonActions';
import { actionGetKitEditorStatus } from 'store/actions/managementUserActions';
import { actionUpdateAssetInList } from 'store/actions/assetsActions';
import { actionGetKitsList, actionUpdateKitInList } from 'store/actions/kitsActions';
import { actionSetClientList } from '../actions/websocketActions';

function subscribe(socket) {
  return eventChannel((emitter) => {
    socket.on('connect', () => {
      emitter('ONLINE');
    });
    socket.on('disconnect', () => {
      emitter('OFFLINE');
    });
    socket.on('messages', (message) => {
      if (message.data && message.data.action) {
        emitter(message.data);
      }
    });
    return () => {};
  });
}

function* listenAction(socket) {

  //const userActive = yield select(getUser);
  //Translations
  //let t = utilTranslations(userActive.language || 'de', 'users');


  try {
    const channel = yield call(subscribe, socket);
    while (true) {
      const data = yield take(channel);

      //Local events
      if (data === 'ONLINE') {

        //Get the last saved action from the socket
        const last = yield select(getWebsocketLastAction);

        //If recovered from offline socket
        if (last === 'OFFLINE') {
        }
        
        yield put(actionWsStatus('online'));
      }
      if (data === 'OFFLINE') {
        yield put(actionWsStatus('offline'));
      }

      //Save the last received action
      yield put(actionSetLastData(data));

      //Backend signals
      const { action } = data;
      
      if (CONSTANTS.hasOwnProperty(action)) {
        switch (action) {
          case CONSTANTS.WS_ALERT:
            const { module, info } = data;

            if (module === 'kit-management') {
              switch(info) {
                case "kit-form-state-change":
                  yield put(actionGetKitEditorStatus())
                  break;

                case "kit-created": {
                  const { page, limit } = yield select(getKitList);
                  yield put(actionGetKitsList(page,limit));
                  break;
                }

                case "kit-data-change": 
                case "kit-deleted": {
                  const { kit_id, kit_data } = data.data;
                  yield put(actionUpdateKitInList(kit_id, kit_data));
                  break;
                }
              }
            }

            if (module === 'asset-management') {
              switch(info) {
                case "asset-state-change":
                  const { asset_id, status } = data.data;
                  yield put(actionUpdateAssetInList(asset_id, status));
                  break;
              }
            }
            break;
          default:
            break;
        }
      }
    }
  } catch (error) {
    console.log(error);
  }
}

// function* emitterAction(socket) {
//   while (true) {
//     const { action } = yield take(CONSTANTS.WS_EMIT_ACTION);
//     console.log("saga", action);
//     socket.emit("message", action);
//   }
// }

function* flow() {
  try {
    while (true) {
      yield take(CONSTANTS.USERS_SET);
      const user = yield select(getUser);
      if (user._id) {
        const socket = yield call(WsService.connect);
        const task = yield fork(listenAction, socket);
        // yield fork(emitterAction, socket);
        console.log('* ===> WS Saga online');
        yield put(actionWsStatus('online'));
        yield take(CONSTANTS.USERS_LOGOUT);
        yield cancel(task);
        console.log('* <=== WS Saga offline');
        yield put(actionWsStatus('offline'));
        yield call(WsService.disconnect);
      }
    }
  } catch (error) {
    console.log('* <=== WS Saga ERROR: ' + error.message);
    yield put(actionWsStatus('offline'));
    yield call(WsService.disconnect);
  }
}


function* sagaWebsocketClients() {
  try {
    //Send recovery password to email
    const result = yield call(WsService.getConnections, "all", "all");
    
    if (result.status >= 400) {
      throw new Error("Request failed");
    }

    yield put(actionSetClientList(result.data));
  } catch (error) {
    // toast.error('An error ocurred while processing your request.');
  }
}

export function* wsSaga() {
  console.log('*Main WS Saga');
  yield takeEvery(CONSTANTS.WS_GET_CLIENTLIST, sagaWebsocketClients);
  yield fork(flow);
}

